export class AppError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options)
    this.name = new.target.name
  }
}

export class HttpError extends AppError {
  constructor(
    public readonly status: number,
    message: string,
    options?: ErrorOptions,
  ) {
    super(message, options)
  }
}

export class BusinessError extends AppError {
  constructor(
    public readonly code: number,
    message: string,
    options?: ErrorOptions,
  ) {
    super(message, options)
  }
}

export class AuthExpiredError extends BusinessError {}
export class ValidationError extends AppError {}

/** Axios 和浏览器 Fetch 对取消请求使用不同错误形态，页面统一在这里判断。 */
export function isCanceledRequest(error: unknown): boolean {
  if (error instanceof DOMException && error.name === 'AbortError') return true
  return Boolean(
    error && typeof error === 'object' && 'code' in error && error.code === 'ERR_CANCELED',
  )
}
